import { buildVerticalLines } from '../../../../utils/charts/renderers';

const edgePadding = 8;
const lineColor = '#E1E5EB';

const applyEdgePadding = (chart) => {
  const axis = chart.xAxis?.[0];
  if (!axis || !chart.plotWidth) return false;

  const pad = edgePadding / chart.plotWidth;
  const { minPadding = 0, maxPadding = 0 } = axis.options;
  if (Math.abs(minPadding - pad) < 0.0005 && Math.abs(maxPadding - pad) < 0.0005) return false;

  chart.update({ xAxis: { minPadding: pad, maxPadding: pad } });
  return true;
};

const drawEdgeLines = (chart, renderEdgeLines) => {
  const axis = chart.xAxis?.[0];
  if (!axis || !renderEdgeLines) return;

  const right = axis.pos + axis.len;
  renderEdgeLines(chart.renderer, [
    { left: axis.pos, top: chart.plotHeight + chart.plotTop, width: 1, height: 5 },
    { left: right - 1, top: chart.plotHeight + chart.plotTop, width: 1, height: 5 },
  ]);
};

const alignEdgeLabels = (chart) => {
  const axis = chart.xAxis?.[0];
  const positions = axis?.tickPositions;
  if (!positions || positions.length < 2) return;

  const firstLabel = axis.ticks[positions[0]]?.label;
  const lastLabel = axis.ticks[positions[positions.length - 1]]?.label;
  if (firstLabel) firstLabel.attr({ align: 'left', x: axis.pos + edgePadding });
  if (lastLabel) lastLabel.attr({ align: 'right', x: axis.pos + axis.len - edgePadding });
};

export const createEdgeLinesRenderer = () => buildVerticalLines({ fill: lineColor });

export const applyEdgeDecorations = (chart, renderEdgeLines, { alignLabels = true } = {}) => {
  if (!renderEdgeLines) return false;
  if (applyEdgePadding(chart)) return true;
  drawEdgeLines(chart, renderEdgeLines);
  if (alignLabels) alignEdgeLabels(chart);
  return false;
};
